import merge from 'lodash/merge';
import { Dimensions, StyleSheet } from 'react-native';
import { toastConfig, tokens } from '../../constants';
import { checkIsPlatform } from '../../utils';
export var getToastPosition = (isLargeScreen, props) => {
  var TOAST_GUTTER = 16;
  var position = props.position,
    desktopPosition = props.desktopPosition,
    version = props.version,
    desktopVersion = props.desktopVersion,
    width = props.width,
    verticalOffset = props.verticalOffset;
  var windowWidth = Dimensions.get('window').width;
  var _version = isLargeScreen && desktopVersion || version;
  var isFullWidth = _version === 'variable-width';
  var _width = isFullWidth ? windowWidth : width;
  var toastWidth = _width - TOAST_GUTTER * 2;
  var _position = isLargeScreen && desktopPosition || position;
  var leftSpaceForCenter = windowWidth / 2 - toastWidth / 2;
  var positionStyle = _position === 'none' ? 'relative' : checkIsPlatform('web') ? 'fixed' : 'absolute';
  var style = {
    none: {
      top: 'auto',
      left: 'auto'
    },
    'top-left': {
      top: TOAST_GUTTER + verticalOffset,
      left: TOAST_GUTTER
    },
    'top-center': {
      top: TOAST_GUTTER + verticalOffset,
      left: leftSpaceForCenter
    },
    'top-right': {
      top: TOAST_GUTTER + verticalOffset,
      right: TOAST_GUTTER
    },
    'bottom-left': {
      bottom: TOAST_GUTTER + verticalOffset,
      left: TOAST_GUTTER
    },
    'bottom-center': {
      bottom: TOAST_GUTTER + verticalOffset,
      left: leftSpaceForCenter
    },
    'bottom-right': {
      bottom: TOAST_GUTTER + verticalOffset,
      right: TOAST_GUTTER
    }
  };
  return Object.assign({
    position: positionStyle,
    width: toastWidth
  }, style[_position]);
};
export var getToastAnimationStyles = fadeAnimRef => {
  return {
    opacity: fadeAnimRef
  };
};
export var getToastStyles = (isLargeScreen, props) => {
  var _a;
  var config = props.config,
    state = props.state,
    _props$iconAlignment = props.iconAlignment,
    iconAlignment = _props$iconAlignment === void 0 ? 'center' : _props$iconAlignment,
    _props$notifierAlignm = props.notifierAlignment,
    notifierAlignment = _props$notifierAlignm === void 0 ? 'center' : _props$notifierAlignm;
  var toastState = (_a = config === null || config === void 0 ? void 0 : config.state) === null || _a === void 0 ? void 0 : _a[state];
  var backgroundColor = toastState.backgroundColor;
  var borderColor = toastState.borderColor;
  var positionStyle = getToastPosition(isLargeScreen, props);
  return StyleSheet.create({
    container: Object.assign(Object.assign({
      backgroundColor,
      borderWidth: 1,
      borderColor,
      borderRadius: tokens.borderRadius.BORDER_RADIUS_12,
      paddingHorizontal: tokens.spacing.SPACING_16,
      paddingVertical: tokens.spacing.SPACING_13,
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'row'
    }, positionStyle), {
      zIndex: 1000
    }),
    toastContainer: {
      display: 'flex',
      flexDirection: 'row',
      flex: 1
    },
    iconStyles: {
      alignSelf: iconAlignment === 'center' ? 'center' : 'flex-start',
      marginRight: tokens.spacing.SPACING_6,
      flexShrink: 0
    },
    notifierStyles: {
      alignSelf: notifierAlignment === 'center' ? 'center' : 'flex-start',
      marginLeft: tokens.spacing.SPACING_6,
      flexShrink: 0
    },
    typographyStyles: {
      flex: 1
    }
  });
};
export var getToastProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(toastConfig === null || toastConfig === void 0 ? void 0 : toastConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.toast) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};